import React, { useEffect, useState } from "react";
import Navbar from "../Navbar/Navbar";
import "./Gem.css"
import { getPendingGemBidList, addGemBidDetails, markGemBidPendingToDone } from "../../Redux/Gem/Action";
import { getCustomerList } from "../../Redux/Config/Action";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import NewDataTable from "../DataTable/NewDataTable";
import { format } from "date-fns";
import { FaCircleCheck, FaEye, FaListUl } from "react-icons/fa6";
import DatePicker from "react-datepicker";
import { useNavigate } from "react-router-dom";

const GemPendingList = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const token = localStorage.getItem("token");
    const loginId = localStorage.getItem("loginId");
    const { pendingGemBidList } = useSelector((store) => store.gem);
    const {customerlist} = useSelector((store) => store.config);
    const [show, setShow] = useState(false);
    const [showRemakrs, setShowRemakrs] = useState(false);

    const [gemBidData, setGemBidData] = useState({
        bidDataId: "",
        customerName: "",
        contactPerson: "",
        contactAddress: "",
        preBid: "N",
        preBidDate: new Date(),
        remarks: "",
        gemFileLink: "",
    });

    const [bidDetails, setBidDetails] = useState({
        bidNumber: "",
        bidTitle: "",
        customerName: "",
        contactPerson: "",
        contactAddress: "",
        preBid: "",
        preBidDate: "",
        status: "",
        startDate: "",
        endDate: "",
        remarks: "",
        gemFileLink: "",
    })

    useEffect(() => {
        dispatch(getPendingGemBidList(token));
        dispatch(getCustomerList(token));
    }, [dispatch, token, loginId]);

    const Tooltip = ({ text, children }) => {
        return (
            <div className="tooltip-container">
                {children}
                <div className="tooltip">{text}</div>
            </div>
        );
    };

    const handleAddClick = (row) => {
        setGemBidData({
            ...gemBidData, bidDataId: row.bidDataId,
            customerName: row?.customerName || "",
            contactPerson: row?.contactPerson || "",
            contactAddress: row?.contactAddress || "",
            preBid: row?.preBid == null ? "" : (row.preBid === "Yes" ? "Y" : "N"),
            preBidDate: row?.preBidDate || new Date(),
            remarks: row?.remarks || "",
            gemFileLink: row?.gemFileLink || "",

        });
        setBidDetails({
            bidNumber: row?.bidNumber || "-",
            startDate: row?.startDate
                ? format(new Date(row.startDate), "dd-MM-yyyy")
                : "-",
            endDate: row?.endDate
                ? format(new Date(row.endDate), "dd-MM-yyyy")
                : "-",
        });

        setShow(true)
    };

    const handleRemakrsClick = (row) => {
        setBidDetails({
            bidNumber: row?.bidNumber || "-",
            bidTitle: row?.bidTitle || "-",
            customerName: row?.customerName || "-",
            contactPerson: row?.contactPerson || "-",
            contactAddress: row?.contactAddress || "-",
            preBid: row?.preBid || "-",
            preBidDate: row?.preBidDate || "-",
            status: row?.status || "-",
            startDate: row?.startDate || "-",
            endDate: row?.endDate || "-",
            remarks: row?.remarks || "-",
            gemFileLink: row?.gemFileLink || null,
        })
        setShowRemakrs(true);
    }

    const handleSubmit = async (e) => {
        e.preventDefault();

        const result = await Swal.fire({
            title: "Are you sure?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, submit it!",
            cancelButtonText: "No, cancel",
        });
        if (result.isConfirmed) {
            dispatch(addGemBidDetails(gemBidData, token))
                .then((response) => {
                    if (response.statusCode === "00") {
                        dispatch(getPendingGemBidList(token));
                        setShow(false);
                        clearLeaveInputFields();
                        Swal.fire({
                            title: "Success!",
                            text: response.statusDesc,
                            icon: "success",
                            timer: 2000,
                            showConfirmButton: false,
                        });
                    } else {
                        Swal.fire({
                            title: "Error!",
                            text: response.error,
                            icon: "error",
                            confirmButtonText: "OK",
                        });
                    }
                })
                .catch(() => {
                    Swal.fire({
                        title: "Error!",
                        text: "There was an error inserting  the gem bid details.",
                        icon: "error",
                        confirmButtonText: "OK",
                    });
                })
        }
    };

    const handleDone = async (bidDataId) => {
        const result = await Swal.fire({
            title: "Are you sure?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, submit it!",
            cancelButtonText: "No, cancel",
        });
        if (result.isConfirmed) {
            dispatch(markGemBidPendingToDone(bidDataId, token))
                .then((response) => {
                    if (response.statusCode === "00") {
                        Swal.fire({
                            title: "Success!",
                            text: response.statusDesc,
                            icon: "success",
                            timer: 2000,
                            showConfirmButton: false,
                        });
                        navigate("/gemCompletedList");

                    } else {
                        Swal.fire({
                            title: "Error!",
                            text: response.error,
                            icon: "error",
                            confirmButtonText: "OK",
                        });
                    }
                })
                .catch(() => {
                    Swal.fire({
                        title: "Error!",
                        text: "Some thing went wrong. Try again later",
                        icon: "error",
                        confirmButtonText: "OK",
                    });
                })
        }

    }

    const columns = [
        {
            name: "SN",
            cell: (_, index) => index + 1,
            sortable: false,
            width: "80px",
            align: "center",
        },
        {
            name: "Bid Number",
            selector: (row) => row?.bidNumber || "-",
            sortable: true,
            align: "left",
        },
        {
            name: "Bid Title",
            selector: (row) => row?.bidTitle || "-",
            sortable: true,
            align: "center",
        },
        {
            name: "End Date",
            cell: (row) => {
                if (!row.endDate) return "-";

                const date = format(new Date(row.endDate), "dd-MM-yyyy");
                const time = format(new Date(row.endDate), "HH:mm a");

                return (
                    <div style={{ whiteSpace: "pre-line", textAlign: "center" }}>
                        {`${date}\n${time}`}
                    </div>
                );
            },
            sortable: true,
            align: "center",
        },
        {
            name: "Customer Name",
            selector: (row) => row?.customerName || "-",
            sortable: true,
            align: "center",
        },
        {
            name: "Contact Address",
            selector: (row) => row?.contactAddress || "-",
            sortable: true,
            align: "center",
        },
        {
            name: "Pre Bid",
            selector: (row) => row?.preBid || "-",
            sortable: true,
            align: "center",
        },
        {
            name: "Pre Bid Date",
            selector: (row) => {
                if (!row?.preBidDate) return "-";
                return format(new Date(row.preBidDate), "dd-MM-yyyy");
            },
            sortable: true,
            align: "center",
        },
        {
            name: "Remarks",
            selector: (row) => row?.remarks || "-",
            sortable: true,
            align: "center",
        },
        {
            name: "Action",
            selector: (row) => row,
            sortable: false,
            align: "center",
            cell: (row) => (
                <>
                    <Tooltip text="Update Details">
                        <button
                            type="button"
                            className="btn btn-success btn-sm me-2"
                            onClick={() => handleAddClick(row)}
                        >
                            <FaListUl size={12} />
                        </button>
                    </Tooltip>
                    <Tooltip text="Done">
                        <button type="button" className="btn btn-primary btn-sm me-2" onClick={() => handleDone(row.bidDataId)}>
                            <FaCircleCheck size={12} />
                        </button>

                    </Tooltip>
                    <Tooltip text="Preview">
                        <button type="button" className="btn btn-secondary btn-sm" onClick={() => handleRemakrsClick(row)}>
                            <FaEye size={12} />
                        </button>

                    </Tooltip>
                </>

            ),

        },
    ];


    const clearLeaveInputFields = () => {
        setGemBidData({
            bidDataId: "",
            customerName: "",
            contactPerson: "",
            contactAddress: "",
            preBid: "N",
            preBidDate: new Date(),
            remarks: "",
            gemFileLink: "",
        });
    };

    const handleClose = () => {
        clearLeaveInputFields();
        setShow(false);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (value && /^[\s]/.test(value)) {
            e.preventDefault();
            return;
        }
        setGemBidData(prev => ({
            ...prev,
            [name]: value
        }));

    };

    const handleDateChange = (date, name) => {
        setGemBidData({
            ...gemBidData,
            [name]: date ? format(date, "yyyy-MM-dd") : ""
        });
    }
    return (
        <div>
            <Navbar />

            <div className="main-content">
                <div className="container-fluid mt-4">
                    <div className="card3">
                        <div className="card-body">
                            <NewDataTable
                                columns={columns}
                                data={pendingGemBidList || []}
                                tableName="GeM PENDING LIST"
                                totalRecord={pendingGemBidList?.length ?? 0}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div
                className={`modal leave-modal ${show ? "d-block" : "d-none"}`}
                tabIndex="-1"
                style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
            >
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">
                                {bidDetails.bidNumber} <br />
                                Start Date: {bidDetails.startDate} & End Date: {bidDetails.endDate}
                            </h5>

                            <button
                                type="button"
                                className="btn-close"
                                onClick={handleClose}
                            ></button>
                        </div>
                        <div className="modal-body">
                            <form onSubmit={handleSubmit}>
                                <div className="row mb-1">
                                    <div className="col-md-6">
                                        <label htmlFor="customerName" className="form-label">
                                            Customer name:
                                        </label>
                                        <select
                                            className="form-select"
                                            name="customerName"
                                            value={gemBidData.customerName || ""}
                                            onChange={handleChange}
                                        >
                                            <option value="">Select..</option>
                                            {customerlist && customerlist.length > 0 &&
                                                customerlist
                                                    .map((item) => (
                                                        <option key={item.customerId} value={item.customerShortName}>
                                                            {item.customerShortName}
                                                        </option>
                                                    ))
                                            }
                                        </select>
                                    </div>
                                    <div className="col-md-6">
                                        <label htmlFor="contactPerson" className="form-label">
                                            Contact Person:
                                        </label>
                                        <input
                                            type="text"
                                            name="contactPerson"
                                            value={gemBidData.contactPerson || ""}
                                            onChange={handleChange}
                                            className="form-control"
                                        />
                                    </div>
                                </div>
                                <div className="row mb-1">
                                    <div className="col-md-6">
                                        <label htmlFor="preBid" className="form-label">
                                            Pre Bid:
                                        </label>
                                        <select
                                            className="form-select"
                                            name="preBid"
                                            value={gemBidData.preBid || ""}
                                            onChange={handleChange}
                                        >
                                            <option value="N">No</option>
                                            <option value="Y">Yes</option>
                                        </select>
                                    </div>
                                    {gemBidData.preBid === "Y" && <div className="col-md-6">
                                        <label htmlFor="preBidDate" className="form-label">
                                            Pre Bid Date:
                                        </label>
                                        <DatePicker
                                            selected={gemBidData.preBidDate ? new Date(gemBidData.preBidDate) : null}
                                            onChange={(date) => handleDateChange(date, "preBidDate")}
                                            className="form-control"
                                            dateFormat="dd-MM-yyyy"
                                            placeholderText="Pre Bid Date"
                                            showYearDropdown
                                            showMonthDropdown
                                            dropdownMode="select"
                                            onKeyDown={(event) => event.preventDefault()}
                                        />
                                    </div>
                                    }
                                </div>
                                <div className="row mb-1">
                                    <div className="col-md-6">
                                        <label htmlFor="contactAddress" className="form-label">
                                            Contact Address:
                                        </label>
                                        <input
                                            type="text"
                                            name="contactAddress"
                                            value={gemBidData.contactAddress || ""}
                                            onChange={handleChange}
                                            className="form-control"
                                        />
                                    </div>
                                    <div className="col-md-6">
                                        <label htmlFor="gemFileLink" className="form-label">
                                            GeM File Link:
                                        </label>
                                        <input
                                            type="text"
                                            name="gemFileLink"
                                            value={gemBidData.gemFileLink || ""}
                                            onChange={handleChange}
                                            className="form-control"
                                        />
                                    </div>
                                </div>
                                <div className="row mb-1">
                                    <div className="col-md-12">
                                        <label className="form-label" htmlFor="remarks">
                                            Remarks:
                                        </label>
                                        <textarea
                                            className="form-control"
                                            name="remarks"
                                            value={gemBidData.remarks || ""}
                                            onChange={handleChange}
                                        ></textarea>
                                    </div>
                                </div>
                                <div className="text-center">
                                    <button type="submit" className="btn btn-success mt-3">
                                        Submit
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            {showRemakrs && (
                <div
                    className="modal fade leave-modal show"
                    tabIndex="-1"
                    style={{
                        display: "block",
                        backgroundColor: "rgba(0,0,0,0.5)",
                    }}
                >
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Bid Details</h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={() => setShowRemakrs(false)}
                                ></button>
                            </div>
                            <div className="modal-body">
                                <div className="bid-details-container">
                                    <div className="row mb-3">
                                        <div className="col-md-4">
                                            <h6 className="fw-bold">Bid Number:</h6>
                                            <p>{bidDetails.bidNumber || "-"}</p>
                                        </div>
                                        <div className="col-md-4">
                                            <h6 className="fw-bold">Start Date:</h6>
                                            <p>{bidDetails.startDate
                                                ? format(new Date(bidDetails.startDate), "dd-MM-yyyy  hh:mm a")
                                                : "-"}
                                            </p>
                                        </div>
                                        <div className="col-md-4">
                                            <h6 className="fw-bold">End Date:</h6>
                                            <p>{bidDetails.endDate
                                                ? format(new Date(bidDetails.endDate), "dd-MM-yyyy  hh:mm a")
                                                : "-"}</p>
                                        </div>

                                    </div>
                                    <div className="row mb-3">
                                        <div className="col-md-12">
                                            <h6 className="fw-bold">Bid Title:</h6>
                                            <p>{bidDetails.bidTitle || "-"}</p>
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <div className="col-md-4">
                                            <h6 className="fw-bold">Customer Name:</h6>
                                            <p>{bidDetails.customerName || "-"}</p>
                                        </div>
                                        <div className="col-md-4">
                                            <h6 className="fw-bold">Contact Person:</h6>
                                            <p>{bidDetails.contactPerson || "-"}</p>
                                        </div>
                                        <div className="col-md-4">
                                            <h6 className="fw-bold">Contact Address:</h6>
                                            <p>{bidDetails.contactAddress || "-"}</p>
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <div className="col-md-4">
                                            <h6 className="fw-bold">Pre Bid:</h6>
                                            <p>{bidDetails.preBid || "-"}</p>
                                        </div>
                                        {bidDetails.preBid === "Yes" && (
                                            <div className="col-md-4">
                                                <h6 className="fw-bold">Pre-Bid Date:</h6>
                                                <p>
                                                    {bidDetails.preBidDate
                                                        ? format(new Date(bidDetails.preBidDate), "dd-MM-yyyy")
                                                        : "-"}
                                                </p>
                                            </div>
                                        )}
                                        <div className={`${bidDetails.preBid === "Yes" ? "col-md-4" : " col-md-8"}`}>
                                            <h6 className="fw-bold">GeM File:</h6>
                                            <p> {bidDetails.gemFileLink ? (<a href={bidDetails.gemFileLink} target="_blank" className="" > {bidDetails.gemFileLink} </a>) : ("-")} </p>
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <div className="col-md-12">
                                            <h6 className="fw-bold">Remarks:</h6>
                                            <p>{bidDetails.remarks || "No Remarks"}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            )}
        </div>

    );

};

export default GemPendingList;
